import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { Form, Button } from "react-bootstrap";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  AddToolTip,
} from "../../../../../components";
import { useRouterParams } from "../../../../../abstracts";
import { getPlansLoanRepayments } from "../../../../../services";
import {
  usDateFormat,
  formFields,
  manageCensusFormNames,
  usCurrency,
} from "../../../../../utils";
import { Formik, Field } from "formik";

var defaultStartDate = new Date();
defaultStartDate.setDate(defaultStartDate.getDate() - 120);
defaultStartDate = usDateFormat(defaultStartDate);
const defaultEndDate = usDateFormat(new Date());
const columns = [
  {
    label: "Loan ID",
    className: "column-loadId",
    columnName: "loanId",
  },
  {
    label: "Repayment Date",
    className: "column-repaymentDate",
    columnName: "repaymentDate",
  },
  {
    label: "Repayment Amount",
    className: "column-repaymentAmount",
    columnName: "repaymentAmount",
  },
  {
    label: "Updated Through",
    className: "column-updatedThrough",
    columnName: "uploadedThrough",
  },
  {
    label: "Date Time Loaded",
    className: "column-dateTimeLoaded",
    columnName: "uploadedDate",
  },
  {
    label: "Comments",
    className: "column-comments",
    columnName: "comments",
    link: `link`,
  },
];

const LoanRepayments = (props) => {
  const [filteredResponse] = useState([]);
  const { planId, censusId } = useRouterParams();
  const formName = manageCensusFormNames.HOURS;
  const fields = formFields[formName];
  const [response, setResponse] = useState([]);
  // const { response } = useRequest({
  //   method: getPlansLoanRepayments,
  //   payload: {
  //     planId: planId,
  //     employeeId: parseInt(censusId),
  //     startDate: defaultStartDate,
  //     endDate: defaultEndDate,
  //   },
  //   defaultResponse: filteredResponse,
  // });

  useEffect(() => {
    getPlansLoanRepayments({
      planId: parseInt(planId),
      employeeId: parseInt(censusId),
      startDate: defaultStartDate,
      endDate: defaultEndDate,
    }).then((response) => {
      setResponse(response);
    });
  }, []);
  const onFormSubmit = {};
  const onFilter = (values) => {
    getPlansLoanRepayments({
      planId: parseInt(planId),
      employeeId: parseInt(censusId),
      startDate: values.startDate,
      endDate: values.endDate,
    }).then((response) => {
      setResponse(response);
    });
  };
  return (
    <>
      <div className="w-100">
        <div className="d-flex w-100 align-items-center justify-content-between">
          <div className="plan-sub-heading">Show records of period</div>
        </div>
        <Formik
          initialValues={{
            startDate: defaultStartDate,
            endDate: defaultEndDate,
          }}
          onSubmit={onFormSubmit}
          enableReinitialize
        >
          {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
            const onDaySelected = (fieldName, value) => {
              setFieldValue(fieldName, value);
            };
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <div
                  className="d-flex align-items-center justify-content-between hoursHeader"
                  style={{ width: "65%" }}
                >
                  {" "}
                  <Field
                    size="smd"
                    label="Start Date"
                    name={fields.startDate}
                    value={usDateFormat(values[fields.startDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.startDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.startDate, value)
                        }
                        value={usDateFormat(values[fields.startDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                  <Field
                    size="smd"
                    label="End Date"
                    name={fields.endDate}
                    value={usDateFormat(values[fields.endDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.endDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.endDate, value)
                        }
                        value={usDateFormat(values[fields.endDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                  <Button
                    onClick={() => onFilter(values)}
                    type="button"
                    className="align-center center-align"
                  >
                    Go
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className="w-100 loan-container">
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {response.map((loanRepayment, index) => {
              return (
                <Table.Tr key={index}>
                  {columns.map((item, cellIndex) => {
                    return (
                      <Table.Td key={cellIndex} className={item.className}>
                        {loanRepayment[item.columnName] === null ||
                        loanRepayment[item.columnName] === "" ? (
                          "-"
                        ) : item.dataMapper ? (
                          item.dataMapper[loanRepayment[item.columnName]]
                        ) : item.columnName === "repaymentAmount" ? (
                          usCurrency(loanRepayment[item.columnName])
                        ) : item.columnName === "repaymentDate" ? (
                          usDateFormat(loanRepayment[item.columnName])
                        ) : item.columnName === "comments" ||
                          item.columnName === "uploadedThrough" ? (
                          <AddToolTip
                            name={loanRepayment[item.columnName] || "-"}
                            placement="top"
                          >
                            {loanRepayment[item.columnName] || "-"}
                          </AddToolTip>
                        ) : (
                          loanRepayment[item.columnName]
                        )}
                      </Table.Td>
                    );
                  })}
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </div>
    </>
  );
};

export default LoanRepayments;
